// extracted by mini-css-extract-plugin
module.exports = {"copyClientConfigurationButton":"baseClientForm_copyClientConfigurationButton__1gKtl"};